export const LOGIN_USER = "LOGIN_USER";
export const LOGGED_USER = "LOGGED_USER";
export const LOGGOUT_USER = "LOGGOUT_USER";
